<template>
  <div class="w1200 orderlist">
      <div class="mtitle">我的订单</div>
      <el-table class="mt_20" 
        :data="tableData" :header-cell-style="{ background: '#F4F8FC' }"
        border
        style="width: 100%">
        <el-table-column
        prop="orderno" align="center"
        label="订单号">
        </el-table-column>
        <el-table-column
        prop="yjsjlx_name" align="center"
        label="方案名称">
        </el-table-column>
        <el-table-column align="center" width="100"
        label="订单状态">
 <template slot-scope="scope">
           {{ scope.row.paystatus=='2'?'已付款':'未付款' }}
        </template>
        </el-table-column>
        <el-table-column
        prop="payamount" align="center" width="100"
        label="金额">
        </el-table-column>
        <el-table-column
        prop="createtime" align="center" width="200"
        label="下单时间">
        </el-table-column>
        <el-table-column
        align="center" width="200"
        label="操作">
        <template slot-scope="scope">
            <template v-if="scope.row.paystatus=='2'">
            <el-link type="primary" @click="edit(scope.row.id)">编辑</el-link>
            <el-link type="primary" class="ml_10" @click="down(scope.row)">下载word</el-link>
            </template>
            <template v-else>
               <el-link type="danger" @click="zhifu(scope.row)">立即支付</el-link>
            </template>
        </template>
        </el-table-column>
    </el-table>
    <div class="fy"  v-if="total>0">
         <el-pagination :popper-append-to-body="false"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchitem.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchitem.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   </div> 

    <el-dialog
        title="支付费用" 
        :visible.sync="dialogVisible"  :close-on-click-modal="false" :close-on-press-escape="false"
        width="500px">
        <div slot="title" class="dialog-title">
              支付费用 <span class="red">￥{{money}}</span>
        </div>
        <div class="pad30">
            <div class="flex flex-c flexx-v">
                <el-radio-group v-model="radio" @change="paychange">
                  <el-radio :label="1"><img style="width:30px;height:30px;margin-right:5px;" src="@/assets/weixin.png">微信支付</el-radio>
                  <el-radio :label="2"><img style="width:30px;height:30px;margin-right:5px;" src="@/assets/zhifubao.png">支付宝支付</el-radio>
                </el-radio-group>
            </div>
            <div class="ewm">
               <canvas ref="qrcodeCanvas"></canvas>
            </div>
            <div class="tip" v-if="radio==1">请用微信扫码支付</div>
            <div class="tip" v-else>请用支付宝扫码支付</div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {getOrderList,payOrder,checkOrderPay,payOrderYuer } from "@/api/index.js"
import QRCode from 'qrcode'
export default {
  data() {
    return {
        searchitem:{
            pageNo:1,
            pageSize:10
        },
         dialogVisible:false,
      radio:1,
        total:0,
     tableData: [],
     money:0,
     payid:'',
      timer:null,
      qrcodeDataURL:''
    }
  },
  mounted(){
this.getlist()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 清除定时器
      this.timer = null; // 清除引用，避免内存泄漏
    }
  },
  methods:{
    zhifu(row){
      this.money=row.payamount
       this.payid=row.id;
        if(this.$store.state.usertype=='1'){
                 this.pay(row.id)
              }else{
                 this.pay2(row.id)
              }
    },
    paychange(){
       clearInterval(this.timer);
       this.timer=null;
       if(this.radio==1){
             this.pay(this.payid)
         }else{
              location.href=this.$imgurl('/api/yixue/payOrder?id='+this.payid+'&type=2')
            //   this.timer=setInterval(() => {
            // this.checkorder(this.payid)
            //  }, 1000);
         }

        
    },
    setimg(url){
       QRCode.toCanvas(this.$refs.qrcodeCanvas, url, {
          width:200,
          margin: 2,
        })
    },
     pay(id){
        payOrder({id:id,type:this.radio}).then(res=>{
          if(res.code==1){
            this.dialogVisible=true;
            setTimeout(() => {
                this.setimg(res.data.code_url)
              
            }, 500);
            
            this.timer=setInterval(() => {
            this.checkorder(id)
             }, 1000);
          }
        })
    },
    checkorder(id){
      checkOrderPay({id:id}).then(res=>{
        if(res.code==1){
            if(res.data.orderstatus==2){
              clearInterval(this.timer);
              this.timer=null
              this.$message({
                    message: '支付成功',
                    type: 'success'
                  });
                this.searchitem.pageNo=1
             this.getlist()     
            }
        }
      })
    },
    pay2(id){
      payOrderYuer({id:id}).then(res=>{
          if(res.code==1){
             this.$message({
                    message: '支付成功',
                    type: 'success'
                  });
                this.searchitem.pageNo=1
             this.getlist()     
          }
        })
    },
    edit(id){
      this.$router.push('/doc?id='+id)
    },
    down(row){
        window.open(this.$imgurl('/'+row.word_url),'_blank')
    },
    getlist(){
      getOrderList(this.searchitem).then(res=>{
        if(res.code==1){
          this.tableData=res.data.rows;
          this.total=res.data.total
        }
     })
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.searchitem.pageSize=val;
        this.getlist()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
         this.searchitem.pageNo=val;
        this.getlist()
      }
  }
};
</script>

<style lang="less">
.orderlist {
  .dialog-title {font-weight: bold;font-size: 22px;}
    .el-radio-group {display: flex}
    .el-radio {
      display:flex;align-items: center;
      .el-radio__label {
         display:flex;align-items: center;font-size: 18px;
      }
    }
    .ewm {
      text-align:center;margin-top:20px;
      img {width:200px;height:200px;}
    }
    .tip {text-align: center;font-size: 14px;margin-top:10px;}
}
</style>
